export type AfterSalesType = 'return' | 'exchange';

export type AfterSalesStatus =
  | 'pending_merchant_review'
  | 'pending_team_price_confirmation'
  | 'pending_user_return'
  | 'pending_merchant_fulfillment'
  | 'pending_team_completion'
  | 'processing_inventory'
  | 'completed'
  | 'merchant_rejected'
  | 'cancelled';

export interface AfterSalesRequest {
  _id: string;
  teamId: string;
  merchantId: string;
  applicationId: string;
  projectIndex: number;
  category: '耗材申请' | '试剂申请';
  applicantId: string;
  applicantName: string;
  merchantName: string;
  type: AfterSalesType;
  status: AfterSalesStatus;
  originalItem: Record<string, unknown>;
  originalOrderAmount: number;
  originalDiscountedOrderAmount: number;
  originalReturnValue: number;
  originalQuantity: number;
  requestedQuantity: number;
  reason: string;
  description?: string;
  evidenceUrls?: string[];
  opened?: boolean;
  affectsResale?: boolean;
  refundMethod?: 'original' | 'team_balance' | '';
  expectedRefundAmount?: number | null;
  replacementItem?: Record<string, unknown> | null;
  merchantDecisionNote?: string;
  merchantConfirmedAmount?: number | null;
  replacementQuote?: number | null;
  priceDifference?: number | null;
  teamPriceComment?: string;
  returnTrackingNumber?: string;
  merchantOutboundTrackingNumber?: string;
  refundReference?: string;
  createdAt: string;
  completedAt?: string | null;
  inventoryAppliedAt?: string | null;
  originalInventoryItemId?: string | null;
  replacementInventoryItemId?: string | null;
}

export const AFTER_SALES_STATUS_TEXT: Record<AfterSalesStatus, string> = {
  pending_merchant_review: '待商家审核',
  pending_team_price_confirmation: '待团队确认金额',
  pending_user_return: '待用户寄回',
  pending_merchant_fulfillment: '待商家退款/换货',
  pending_team_completion: '待团队确认完成',
  processing_inventory: '正在更新库存',
  completed: '已完成',
  merchant_rejected: '商家已拒绝',
  cancelled: '已撤销'
};
